import type { Me } from "@/types/auth"

/**
 * Where an account starts after signing in. System Administrators open the
 * console; client accounts open their own district or organisation dashboard
 * (the scope store defaults to their jurisdiction).
 */
export function landingFor(me: Me): string {
  if (me.capabilities.admin_console) return "/admin"
  return "/overview"
}

/** A post-login return path is used only if it is local and the account may open it. */
export function safeReturnPath(from: string | null, me: Me): string | null {
  if (!from || !from.startsWith("/") || from.startsWith("//") || from.startsWith("/auth")) return null
  if (from.startsWith("/admin")) return me.capabilities.admin_console ? from : null
  return me.capabilities.demo ? from : null
}
